import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import { civilityOptions } from '../../../../shared/utils/data/etablissments-data';

import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from '@justin-s/ngx-intl-tel-input';

import { MissionService } from '../../../../services/mission.service';
import { CandidatService } from '../../../../services/candidat.service';
import { FlagType } from '../../../../shared/utils/enums';
import { FlagService } from '../../../../shared/services/flag.service';
import moment from 'moment';

@Component({
  selector: 'app-first-step-candidat',
  templateUrl: './first-step-candidat.component.html',
  styleUrl: './first-step-candidat.component.scss',
})
export class FirstStepCandidatComponent implements OnInit {


  @Input() form: FormGroup;
  image: string;
  formData: FormData = new FormData();
  @Output() onSubmit = new EventEmitter<any>();
  fonctionOptions: any[];
  domaineOptions: any[];
  user: any;
  loadingSecteur = false;
  maxDate: string;
  phoneMaxLength: number = 10;
  PhoneNumberFormat = PhoneNumberFormat;
  phoneNumber: string | undefined;
  birthDay: string;
  protected readonly civilityOptions = civilityOptions;
  constructor(
    private missionApi: MissionService,
    private condidatApi: CandidatService,
    private flag: FlagService
  ) {}

  /**
   * Init form
   */
  ngOnInit() {
    this.maxDate = moment().subtract(18, 'years').format('YYYY-MM-DD');
    if (this.form.get('worktype')?.value == '') {
      this.form.get('fonction')?.disable();
    }
    this.form.get('worktype')?.valueChanges.subscribe(() => {
      this.form.get('fonction')?.enable();
      this.getPosts();
    });
    if (!this.form.get('worktype')?.value) {
      this.getPosts();
      this.form.get('fonction')?.disable();
    } else {
      this.getPosts();
    }
    this.getSecteur();
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    
  }
  submitDocument(id: any) {
 
  this.condidatApi
      .uploadFileCandidat(this.formData, id)
      .subscribe({
        next: (res) => {
         
          this.condidatApi.getCondidatById(this.user?.collary_id).subscribe(res => {
            this.form.get('photo')?.patchValue(res?.photo)
              localStorage.setItem(
          'candidat',
          JSON.stringify({
            id: res.id,
            firstname: res.firstname,
            fullname: res.fullname,
            mailadress: res.mailadress,
            photo: res.photo,
            lastname: res.firstname,
            typePosteDto: res.typePosteDto,
            typePosteId: res.typePosteId,
            typeSecteurDto: res.typeSecteurDto,
            typeSecteurId: res.typeSecteurId,
            numsiret: res.numsiret,
            numtel: res?.numtel?.replace(/\s+/g, ''),
            numsocialsecurity: res.numsocialsecurity,
            nationality: res.nationality,
            civility: res.civility,
          })
        );
          });
          
        },
        error: (err) => {
         
          this.formData.delete('photo');
          this.flag.displayFlag('Error !', FlagType.error);
        
        },
      });
  }
  getImage(images: any) {
    
     if (images.type) {
      this.image = images[0];
      this.user.imageUrl = images[0];
       this.formData.append('photo', images);
      
       
    }
    
  }
  getPosts() {
    if (this.form.get('worktype')?.value) {
      this.missionApi
        .getPostes(this.form.get('worktype')?.value)
        .then((res) => {
          this.fonctionOptions = res;
        })
        .catch((err) => console.log(err));
    } else {
      this.missionApi
        .getAllPostes()
        .then((res) => {
          this.fonctionOptions = res;
        })
        .catch((err) => console.log(err));
    }
  }
  getSecteur() {
    this.loadingSecteur = true;
    this.missionApi
      .getSecteurs()
      .then((res) => {
        this.loadingSecteur = false;
        this.domaineOptions = res;
      })
      .catch((err) => console.log(err));
  }

  onSiretInputChange(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const numericValue = inputElement.value.replace(/\D/g, '');
  if (numericValue.length > 14) {
    inputElement.value = numericValue.slice(0, 14);
  } else {
    inputElement.value = numericValue;
    }
   this.form.get('numsiret')?.setValue(inputElement.value);

  }
  
  onKeyInputChange(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const numericValue = inputElement.value.replace(/\D/g, '');
  if (numericValue.length > 2) {
    inputElement.value = numericValue.slice(0, 2);
  } else {
    inputElement.value = numericValue;
    }
   this.form.get('key')?.setValue(inputElement.value);
  }

  onSecurityInputChange(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const numericValue = inputElement.value.replace(/\D/g, '');
  if (numericValue.length > 13) {
    inputElement.value = numericValue.slice(0, 13);
  } else {
    inputElement.value = numericValue;
    }
   this.form.get('numsocialsecurity')?.setValue(inputElement.value);
  }

  onInputChange(event: any) {
    
    const inputNumber = event?.number;

    if (!inputNumber) return;


    if (inputNumber.startsWith('0')) {
       this.phoneMaxLength = 10;
    } else {
         this.phoneMaxLength = 9;
    }
    if (inputNumber.length > this.phoneMaxLength) {
      this.phoneNumber = inputNumber.slice(0, this.phoneMaxLength);
      this.form.get('phone')?.setValue(this.phoneNumber);
    } else {
      this.phoneNumber = inputNumber;
    }
  }
  update(arg0: EventEmitter<any>) {
    
    const birthDateValue = this.form.get('birthDay')?.value;
    if (birthDateValue) {
    this.birthDay = moment(birthDateValue).format('YYYY-MM-DD');
    }
     const body = {
        civility: this.form.get('civility')?.value,
        contracttype: null,
        lastname: this.form.get('lastname')?.value,
        firstname: this.form.get('firstname')?.value,
        birthDay: this.birthDay,
        fullname:
          this.form.get('lastname')?.value +
          ' ' +
          this.form.get('firstname')?.value,
        ishandicap: this.form.get('ishandicap')?.value,
        handicapsituation: this.form.get('handicapsituation')?.value,
        isliberal: false,
        mailadress: this.user?.email,
        numsiren: null,
        numrpps: null,
        numsiret: this.form.get('numsiret')?.value,
        socialKey: this.form.get('key')?.value,
        numsocialsecurity: this.form.get('numsocialsecurity')?.value,
        numtel: this.phoneNumber,
        typePosteId: this.form.get('fonction')?.value,
        typeSecteurId: this.form.get('worktype')?.value
      };
      this.condidatApi
        .upadateCandidat(body, this.user?.collary_id)
        .subscribe({
          next: (res) => {
           setTimeout(() => {
          this.submitDocument(this.user?.collary_id);
      }, 500);
          },
          error: (err) => {
            
          },
        });
   arg0.emit();
  }
  // protected readonly domaineOptions = domaineOptions;
  protected readonly CountryISO = CountryISO;
  protected readonly SearchCountryField = SearchCountryField;
}
